
export function shortenAddress(ethAddress){
    if(ethAddress){
        const l = ethAddress.length
        return ethAddress.substring(0, 5) + '....' + ethAddress.substring(l - 5, l - 1)
    }
    return ""
}